import classNames from 'classnames';
import React from 'react';

import { DarkSkeleton } from '@eika/skeleton';

import { SkeletonProps } from './types';

export const ProgressBarSkeleton: React.FC<SkeletonProps> = ({
    wrapperClassName,
    labelSkeleton = <DarkSkeleton height={16} width={170} />,
    className,
    size = 'standard',
}) => (
    <section className={classNames('progress-bar__wrapper', wrapperClassName, 'skeleton')}>
        <div className="progress-bar__label-wrapper skeleton">{labelSkeleton}</div>
        <div className={classNames('progress-bar__element-skeleton', className, size)}>
            <DarkSkeleton height={size === 'standard' ? 4 : 12} width="100%" />
        </div>
    </section>
);

export default ProgressBarSkeleton;
